import React, { memo, useLayoutEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { computeFlyoutTop, isNavPathActive } from '../../../config/navMenuConfig';

const CLOSE_BRIDGE_MS = 150;

/**
 * Panel flotante — alineado al ícono activo, no desplaza contenido.
 */
const NavFlyout = memo(function NavFlyout({
  item,
  railWidth = 64,
  anchorTop = 72,
  onNavigate,
  onMouseEnter,
  onMouseLeave,
  onHeightChange
}) {
  const location = useLocation();
  const panelRef = useRef(null);
  const [top, setTop] = useState(anchorTop);

  useLayoutEffect(() => {
    const el = panelRef.current;
    if (!el) return;
    const height = el.offsetHeight;
    onHeightChange?.(height);
    setTop(computeFlyoutTop(anchorTop, height));
  }, [anchorTop, item, onHeightChange]);

  return (
    <div
      ref={panelRef}
      data-nav-flyout
      className="e0e3-nav-flyout fixed z-[65] w-[min(280px,calc(100vw-5rem))] rounded-xl border border-white/[0.1] bg-e0e3-surface/95 p-3 shadow-xl shadow-black/40 backdrop-blur-md"
      style={{ left: railWidth + 8, top, transition: 'top 140ms ease-out' }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="menu"
      aria-label={item.label}
    >
      <div className="mb-2 border-b border-white/[0.08] pb-2">
        <p className="text-[10px] font-semibold uppercase tracking-widest text-e0e3-muted">Módulo</p>
        <p className="text-sm font-bold text-white">{item.label}</p>
        {item.description && (
          <p className="mt-0.5 text-xs text-e0e3-muted">{item.description}</p>
        )}
      </div>

      <ul className="space-y-0.5">
        {item.submenu.map((sub) => {
          const active = isNavPathActive(location.pathname, sub.path);
          return (
            <li key={sub.path}>
              <Link
                to={sub.path}
                role="menuitem"
                onClick={onNavigate}
                className={`
                  group flex items-center justify-between rounded-lg px-3 py-2.5 text-sm transition duration-150
                  ${active
                    ? 'bg-e0e3-accent/15 font-semibold text-e0e3-accent ring-1 ring-e0e3-accent/25'
                    : 'text-e0e3-muted hover:bg-white/[0.06] hover:text-e0e3-foreground'}
                `}
              >
                <span>
                  {sub.label}
                  {sub.description && (
                    <span className="mt-0.5 block text-[11px] font-normal text-e0e3-muted/80">{sub.description}</span>
                  )}
                </span>
                <FaChevronRight
                  size={10}
                  className={`shrink-0 opacity-0 transition group-hover:opacity-60 ${active ? 'opacity-80 text-e0e3-accent' : ''}`}
                />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
});

export { CLOSE_BRIDGE_MS };
export default NavFlyout;
